import script from "./BaseTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTable.vue?vue&type=script&setup=true&lang=js"

import "./BaseTable.vue?vue&type=style&index=0&id=c5dd8f68&lang=scss&scoped=true"
script.__scopeId = "data-v-c5dd8f68"

export default script